const DEFAULT_MAX_FILE_SIZE = 104857600;
const DEFAULT_MAX_FILENAME_LENGTH = 100;

const parseBooleanOrUndefined = (value: string | undefined): boolean | undefined => {
  if (!value) return undefined;
  const normalized = value.trim().toLowerCase();
  if (normalized === 'true' || normalized === '1') return true;
  if (normalized === 'false' || normalized === '0') return false;
  return undefined;
};

const parsePositiveIntOrDefault = (value: string | undefined, defaultValue: number): number => {
  const trimmedValue = value?.trim();

  if (trimmedValue && /^[1-9]\d*$/.test(trimmedValue)) {
    const parsedValue = Number(trimmedValue);

    if (Number.isSafeInteger(parsedValue)) {
      return parsedValue;
    }
  }

  return defaultValue;
};

export const { VITE_API_URL, VITE_MUI_X_PRO_KEY } = import.meta.env;

export const VITE_APP_VERSION = import.meta.env.VITE_APP_VERSION;
export const VITE_PRODUCT_VERSION = import.meta.env.VITE_PRODUCT_VERSION;

export const VERSION_INFO = {
  uiVersion: VITE_APP_VERSION,
  productVersion: VITE_PRODUCT_VERSION,
} as const;

export const VITE_FF_USE_NEW_BASE_FORM = parseBooleanOrUndefined(
  import.meta.env.VITE_FF_USE_NEW_BASE_FORM
);

export const VITE_MAX_FILE_SIZE = parsePositiveIntOrDefault(
  import.meta.env.VITE_MAX_FILE_SIZE,
  DEFAULT_MAX_FILE_SIZE
);

export const VITE_MAX_FILENAME_LENGTH = parsePositiveIntOrDefault(
  import.meta.env.VITE_MAX_FILENAME_LENGTH,
  DEFAULT_MAX_FILENAME_LENGTH
);

export const COI_ENV = Object.freeze({
  LOCAL: 'localhost',
  DEV: 'coi.dev',
  QA: 'coi.qa',
});

export type COI_ENV = (typeof COI_ENV)[keyof typeof COI_ENV];

/**
 * Determines the current environment based on the window location hostname.
 * Checks if the hostname starts with 'localhost', 'coi.dev', or 'coi.qa' to identify the environment.
 * Returns the corresponding environment enum value or defaults to LOCAL if no match is found.
 */
export function getCoiEnv(): COI_ENV {
  const hostname = window.location.hostname;
  return Object.values(COI_ENV).find((env) => hostname.startsWith(env)) || COI_ENV.LOCAL;
}
